import React from "react";

import { useContentContext } from "../context/content-context";

import HCPPageWrapper from "./components/hcp-page-wrapper";

const ResourceObject = ({ url, title, description, thumb }) => (
  <div key={title} className="half hcp-resource">
    <a href={url || ""} target="_blank" rel="noopener noreferrer">
      <img src={thumb} alt="" />
    </a>
    <div>
      <h6 className="strong" dangerouslySetInnerHTML={{ __html: title }} />
      <p>{description}</p>
    </div>
  </div>
);

const HCPResourcesPage = () => {
  const {
    hcpResources: { provider_resources, patient_resources },
  } = useContentContext();

  return (
    <HCPPageWrapper>
      <section className="section-outer hcp">
        <div className="section-inner mb-5 column text-align-center">
          <h2 className="teal mb-30">
            Useful tools for patients and practices
          </h2>
          <h3 className="blue mb-30">Provider resources</h3>
          <div className="column-container flex-wrap">
            {provider_resources[0].map(ResourceObject)}
          </div>
        </div>
      </section>

      <section className="section-outer hcp background-light-teal-gradient hcp-patient-resources">
        <div className="section-inner mb-0 column text-align-center">
          <h3 className="blue mb-30">Patient resources</h3>
          <div className="column-container flex-wrap">
            {patient_resources[0].map(ResourceObject)}
          </div>
        </div>
      </section>
    </HCPPageWrapper>
  );
};

export default HCPResourcesPage;
